module.exports = __webpack_public_path__ + "static/media/2.aeeadabd.png";